var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from "./component";
var Toast = /** @class */ (function (_super) {
    __extends(Toast, _super);
    function Toast(args) {
        var _this = _super.call(this, args) || this;
        _this.addCloseEvent = function () {
            var _a;
            (_a = _this.element.querySelector('.btn-close')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', function () {
                console.log('close');
                _this.componentInstance.hide();
                _this.element.remove();
            });
        };
        _this.show = function () {
            _this.setElement();
            // document.body.appendChild(this.element);
            _this.element.removeAttribute('data-mdb-toast-initialized');
            _this.setComponentInstance();
            document.body.appendChild(_this.element);
            _this.attachEventListeners();
            _this.addCloseEvent();
            //todo position, color, 
            //todo if this.options.position  <== add styles based on
            // const instance = mdb.Toast.getOrCreateInstance(this.element);
            // instance.update({position:'top-right'})
            // instance.show()
            _this.componentInstance.show();
            console.log(_this.componentInstance, 'this.componentinstance --> should be Toast');
        };
        _this.name = "toast";
        return _this;
    }
    return Toast;
}(Component));
export { Toast };
;
